/**
 * The default background image value. Used in tailwind.config.js to configure the image for use in the background-image TailwindCSS utility.
 */
export const defaultBackgroundImage = "default-background";
export const kawhiaBackgroundImage = "kawhia-background";
